import User from './user';
import Job from './job';
import Common from './common';
import Delivery from './delivery'
import {combineReducers} from 'redux';

export default combineReducers({
    User,
    Common,
    Job,
    Delivery
});